import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import ProdottiService from 'services/ProdottiService';
import {PRODOTTI} from '../../configs/AppConfig';
import {CURRENT_COMPANY_PRODOTTI} from 'constants/AuthConstant';
import DbUtils from 'utils/indexDB';

export const initialState = {
    ...PRODOTTI,
    addingProdotto: false,
    addedProdotto: false,
    errorAddProdotto: false,
    updatingProdotto: false,
    updatedProdotto: false,
    errorUpdateProdotto: false
};

const DB_NAME = 'MyProductsDB';
const STORE_NAME = 'products';
const VERSION = 1;
const LAST_SYNC_TIMESTAMP = 'PRODUCTS_LAST_FULL_SYNC';

export const loadProdotti = createAsyncThunk('carica-prodotti', async (data, {rejectWithValue}) => {
    console.log("[loadProdotti]");

    try {
        // Recupera l'ID dell'azienda corrente
        const currentCompanyId = data.documentId;

        // Recupera l'ultima azienda memorizzata e i prodotti in cache
        const lastCompanyId = localStorage.getItem(CURRENT_COMPANY_PRODOTTI);
        const cachedProducts = await DbUtils.getAll(DB_NAME, VERSION, STORE_NAME);

        // Get the last full sync timestamp
        const lastFullSync = localStorage.getItem(LAST_SYNC_TIMESTAMP);
        const now = new Date().getTime();
        const oneDayInMs = 24 * 60 * 60 * 1000; // 24 hours
        const shouldForceFullSync = !lastFullSync || (now - parseInt(lastFullSync)) > oneDayInMs;

        // Force a full sync if:
        // 1. Company has changed
        // 2. There are no cached products
        // 3. It's been more than a day since the last full sync
        if (currentCompanyId !== lastCompanyId || !cachedProducts || cachedProducts.length === 0 || shouldForceFullSync) {
            console.log('Nuova azienda o nessuna cache trovata o sync giornaliero, fetch completo dal server...');

            const response = await ProdottiService.getProdottiLotsByCompanyV2(currentCompanyId);
            console.log("ale-mag ##get product totally 1 ",response)


            /* old version
            const products = response.data.map((item) => ({
                id: item.product.id,
                documentId: item.product.documentId,
                updatedAt: item.product.updatedAt,
                ...item.product,
            }));*/
            /* new version */
            const products = getProduct(response);


            // Update last full sync timestamp
            localStorage.setItem(LAST_SYNC_TIMESTAMP, now.toString());

            // Salva i prodotti e l'ID dell'azienda corrente
            await DbUtils.clearAllAndSaveItem(products, DB_NAME, VERSION, STORE_NAME);

            return {prodotti: products, company: currentCompanyId};
        } else {
            console.log('Stessa azienda, verifico aggiornamenti dalla cache...');

            // Get the server total count to detect if items were deleted
            const countResponse = await ProdottiService.getProdottiLotsByCompanyCount(currentCompanyId);
            const serverProductsCount = countResponse.meta.pagination.total;

            // If server has fewer items than cache, do a full sync to get updated data
            if (serverProductsCount < cachedProducts.length) {
                console.log('Rilevate cancellazioni nel database remoto, eseguo sync completo...');

                const response = await ProdottiService.getProdottiLotsByCompanyV2(currentCompanyId);
                console.log("ale-mag ##get product totally 2 ",response)

                /*old version

                const products = response.data.map((item) => ({
                    id: item.product.id,
                    documentId: item.product.documentId,
                    updatedAt: item.product.updatedAt,
                    ...item.product,
                }));
                 */
                /* new version */
                const products = getProduct(response)

                // Update last full sync timestamp
                localStorage.setItem(LAST_SYNC_TIMESTAMP, now.toString());

                // Replace the cache completely
                await DbUtils.clearAllAndSaveItem(products, DB_NAME, VERSION, STORE_NAME);
                console.log("prodotti aggiornati dopo rilevamento cancellazioni: ", products);

                return {prodotti: products, company: currentCompanyId};
            }

            // Logica esistente per l'aggiornamento incrementale
            const latestUpdatedAt = cachedProducts.reduce((latest, product) => {
                const updatedDate = new Date(product.updatedAt);
                return updatedDate > latest ? updatedDate : latest;
            }, new Date(0));

            console.log("Ultimo aggiornamento PRODOTTI cache:", latestUpdatedAt.toISOString());

            const response = await ProdottiService.getProdottiLotsByCompanyAfterV2(currentCompanyId, latestUpdatedAt.toISOString());

            /* old version
            const updatedProducts = response.data.map((item) => ({
                id: item.product.id,
                documentId: item.product.documentId,
                updatedAt: item.product.updatedAt,
                ...item.product,
            }));
             */
            /* new version */
            const updatedProducts = getProduct(response);

            if (updatedProducts.length > 0) {
                console.log('Ci sono aggiornamenti dal server, aggiorno cache...');
                const mergedProducts = DbUtils.mergeItems(cachedProducts, updatedProducts);
                await DbUtils.saveItem(mergedProducts, DB_NAME, VERSION, STORE_NAME);
                console.log("mergedProducts: ", mergedProducts)
                return {prodotti: mergedProducts, company: currentCompanyId};
            } else {
                console.log('Nessun aggiornamento, uso la cache.');
                return {prodotti: cachedProducts, company: currentCompanyId};
            }
        }
    } catch (err) {
        console.error(err);
        return rejectWithValue('ERRORE');
    }
});

export const nuovoProdotto = createAsyncThunk('aggiungi-prodotto', async (body, {rejectWithValue, getState}) => {
    try {
        const response = await ProdottiService.createFullProduct(body);
        return response.data;
    } catch (err) {
        console.error("err", err);
        return rejectWithValue('ERRORE');
    }
});


export const modificaProdotto = createAsyncThunk('modifica-prodotto', async (body, {rejectWithValue, getState}) => {
    try {
        console.log("ale-debug", body);
        const response = await ProdottiService.modificaProduct(body, body.documentId);
        console.log("ale-debug response", response);
        return getSingleProduct(response.data);
    } catch (err) {
        console.error("err", err);
        return rejectWithValue('ERRORE');
    }
});

const getSingleProduct = (response)=>{
    console.log("response 2",response)
    const warehouseArticles = response.warehouse_articles || [];
    console.log("response 2 warehouseArticles",warehouseArticles)
    const productStock = warehouseArticles.reduce((acc, wa) => {
        if (wa.storage) {
            return acc + (wa.quantity || 0);
        }
        return acc;
    }, 0);
    return {
        totalStock: productStock,
        ...response,
    };
}
const getProduct = (response) =>{
    console.log("## getProduct mapping",response)
    return response.data.map((item) => {
        console.log("getProduct item",item.product)
        const warehouseArticles = item.product.warehouse_articles || [];
        const productStock = warehouseArticles.reduce((acc, wa) => {
            if (wa.storage) {
                return acc + (wa.quantity || 0);
            }
            return acc;
        }, 0);


        return {
            id: item.product.id,
            documentId: item.product.documentId,
            updatedAt: item.product.updatedAt,
            totalStock: productStock,

            ...item.product,
        };
    });
}

export const prodotti = createSlice({
    name: 'prodotti',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(loadProdotti.pending, (state) => {
                state.loadingProdotti = true
                state.loadedProdotti = false
                state.errorProdotti = false
            })
            .addCase(loadProdotti.fulfilled, (state, action) => {
                state.loadingProdotti = false
                state.prodotti = action.payload.prodotti
                state.errorProdotti = false
                state.loadedProdotti = true
                state.currentCompany = action.payload.company
                localStorage.setItem(CURRENT_COMPANY_PRODOTTI, action.payload.company)

            })
            .addCase(loadProdotti.rejected, (state, action) => {
                state.loadingProdotti = false
                state.prodotti = []
                state.loadedProdotti = true
                state.errorProdotti = true
            })
            .addCase(nuovoProdotto.pending, (state) => {
                state.addingProdotto = true
                state.addedProdotto = false
                state.errorAddProdotto = false
            })
            .addCase(nuovoProdotto.fulfilled, (state, action) => {
                state.addingProdotto = false
                state.addedProdotto = true
                state.errorAddProdotto = false
            })
            .addCase(nuovoProdotto.rejected, (state, action) => {
                state.addingProdotto = false
                state.addedProdotto = false
                state.errorAddProdotto = true
            })
            .addCase(modificaProdotto.pending, (state) => {
                state.updatingProdotto = true
                state.updatedProdotto = false
                state.errorUpdateProdotto = false
            })
            .addCase(modificaProdotto.fulfilled, (state, action) => {
                state.updatingProdotto = false
                state.updatedProdotto = true
                state.errorUpdateProdotto = false
                // Update the existing product in the array
                const index = state.prodotti.findIndex(p => p.documentId === action.payload.documentId);
                if (index !== -1) {
                    state.prodotti[index] = action.payload;
                }
            })
            .addCase(modificaProdotto.rejected, (state, action) => {
                state.updatingProdotto = false
                state.updatedProdotto = false
                state.errorUpdateProdotto = true
            });
    }
})

export default prodotti.reducer;
